import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from "../../../../state/hooks";
import { useBestBuyUserConfig } from "../../../../state/dex/hooks";
import { updateBestBuyUserConfig } from "../../../../state/dex/actions";
import { BestBuyExpiration } from "../../../../state/dex/type";
import { ExpirationStatus, useExpirationVerify } from "../../hooks/useTradeVerify";
import { Row, StyledRowLabel, StyledInputWrapper, Input, InputHelpText, StyledReferWrapper, StyledReferLabel, StyledReferItemsWrapper, StyledReferItem, Divider, StyledErrorMsg } from "../../styled";

var DateSelect = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useAppDispatch();

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration;

  var _expiration$split = expiration.split('_'),
      _expiration$split2 = _slicedToArray(_expiration$split, 1),
      customValue = _expiration$split2[0];

  var _useState = useState(ExpirationStatus.DEFAULT),
      status = _useState[0],
      setStatus = _useState[1];

  var dateRef = useRef(null);
  var verifyExpiration = useExpirationVerify();
  var borderColor = useMemo(() => {
    if (status === ExpirationStatus.DEFAULT || status === ExpirationStatus.VERIFIED) return '#e8e9f2';
    return '#e75b55';
  }, [status]);
  var bestBuyExpirationArray = Object.values(BestBuyExpiration);

  var onChange = e => {
    var value = e.target.value;
    if (value === '') return dispatch(updateBestBuyUserConfig({
      expiration: ''
    }));
    var intValue = parseInt(value);

    if (!isNaN(intValue) && intValue >= 0) {
      dispatch(updateBestBuyUserConfig({
        expiration: "".concat(intValue.toString(), "_days")
      }));
    }
  };

  var onSelect = item => {
    dispatch(updateBestBuyUserConfig({
      expiration: item
    }));
  };

  useEffect(() => {
    if (expiration === '') return setStatus(ExpirationStatus.DEFAULT);
    var result = verifyExpiration();
    setStatus(result);
  }, [expiration]);
  return __jsx(Row, null, __jsx(StyledRowLabel, null, t('duration')), __jsx(StyledInputWrapper, {
    borderColor: borderColor,
    onClick: () => {
      var _dateRef$current;

      dateRef === null || dateRef === void 0 || (_dateRef$current = dateRef.current) === null || _dateRef$current === void 0 ? void 0 : _dateRef$current.focus();
    }
  }, __jsx(Input, {
    ref: dateRef,
    inputMode: "numeric",
    onChange: onChange,
    placeholder: "30",
    value: customValue,
    width: "".concat(Math.max(customValue.length * 10, 40), "px")
  }), __jsx(InputHelpText, null, t('day'))), status === ExpirationStatus.MAX_EXPIRATION_ERROR && __jsx(StyledErrorMsg, null, t('best_buy_verify_max_expiration_error')), __jsx(StyledReferWrapper, null, __jsx(StyledReferLabel, null, t('reference')), __jsx(StyledReferItemsWrapper, null, bestBuyExpirationArray.map((item, index) => {
    var _item$split = item.split('_'),
        _item$split2 = _slicedToArray(_item$split, 2),
        value = _item$split2[0],
        unit = _item$split2[1];

    return __jsx(StyledReferItem, {
      key: index,
      onClick: () => onSelect(item)
    }, index !== 0 && __jsx(Divider, null), value + ' ' + t(unit));
  }))));
};

export default DateSelect;